import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import RouteAnalytics from './components/RouteAnalytics';
import AutoAdsReloader from './components/ads/AutoAdsReloader';
import { Suspense, lazy } from 'react';
const HomePage = lazy(() => import('./pages/HomePage'));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const BrowsePage = lazy(() => import('./pages/BrowsePage'));
const CategoriesPage = lazy(() => import('./pages/CategoriesPage'));
const CompanyProfile = lazy(() => import('./pages/CompanyProfile'));
const ValidationPage = lazy(() => import('./pages/ValidationPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const DataRemovalPage = lazy(() => import('./pages/DataRemovalPage'));
const CariversityPage = lazy(() => import('./pages/CariversityPage'));
const CategoryPage = lazy(() => import('./pages/CategoryPage'));
const ArticlePage = lazy(() => import('./pages/ArticlePage'));
const ApiDocsPage = lazy(() => import('./pages/ApiDocsPage'));
const HelpPage = lazy(() => import('./pages/HelpPage'));
const PricingPage = lazy(() => import('./pages/PricingPage'));
const JoinPage = lazy(() => import('./pages/JoinPage'));
const OurTeamPage = lazy(() => import('./pages/OurTeamPage'));
const SeminarsPage = lazy(() => import('./pages/SeminarsPage'));
const StateCompaniesPage = lazy(() => import('./pages/StateCompaniesPage'));
const CompaniesAlphabetPage = lazy(() => import('./pages/CompaniesAlphabetPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (renamed from cacheTime)
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <RouteAnalytics />
          {/* Defer AutoAdsReloader mount to next tick to avoid blocking initial render */}
          <Suspense fallback={null}>
            <AutoAdsReloader />
          </Suspense>
          <ScrollToTop />
          <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50">
            <Header />
            <main>
            <Suspense fallback={<div className="container mx-auto px-4 py-12 text-center">Loading...</div>}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/browse" element={<BrowsePage />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/company/:slug" element={<CompanyProfile />} />
              <Route path="/carrier/:mc" element={<CompanyProfile />} />
              <Route path="/validate" element={<ValidationPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/data-removal" element={<DataRemovalPage />} />
              <Route path="/cariversity" element={<CariversityPage />} />
              <Route path="/cariversity/category/:slug" element={<CategoryPage />} />
              <Route path="/cariversity/:categorySlug/:slug" element={<ArticlePage />} />
              <Route path="/api-docs" element={<ApiDocsPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/pricing" element={<PricingPage />} />
                      <Route path="/join" element={<JoinPage />} />
                      <Route path="/join-us" element={<JoinPage />} />
                      <Route path="/our-team" element={<OurTeamPage />} />
                      <Route path="/seminars" element={<SeminarsPage />} />
                      <Route path="/state/:state" element={<StateCompaniesPage />} />
                      <Route path="/companies/:letter" element={<CompaniesAlphabetPage />} />
                      <Route path="*" element={<NotFoundPage />} />
            </Routes>
            </Suspense>
          </main>
          <Footer />
          <CookieConsent />
        </div>
      </Router>
    </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;